const skillsImage= [
    {
        id: "wdc001",
        title: "Adobe Photoshop"
    },
    {
        id: "wdc002",
        title: "Photopea"
    },
    {
        id: "wdc003",
        title: "Adobe Illustrator"
    },
    {
        id: "wdc004",
        title: "Canva"
    },
    {
        id: "wdc005",
        title: "Figma"
    },
     {
        id: "wdc006",
        title: "Adobe Indesign"
    }
]

export default skillsImage;
